/**
 * /api/alerts — system + breach alerts.
 *
 * Backed by the `alerts` table. Currently populated by error paths
 * (DLQ failures) and will expand as breach/news/compliance writers come
 * online. The Worker shapes the JSON `data` column into a flat row for
 * the dashboard so the page never has to parse the blob itself.
 */

import { z } from "zod";

/** Alert row shape returned to the dashboard. */
export const AlertRowZ = z.object({
  id: z.number().int(),
  /** Free-form category — populated values today: "system", "dlq", "breach", "news". */
  type: z.string(),
  severity: z.enum(["info", "warning", "critical"]),
  account_id: z.string().nullable(),
  pair_id: z.string().nullable(),
  /** Human-readable title — extracted from `data.title` if present, else the type. */
  title: z.string(),
  /** Body — extracted from `data.detail`/`data.message` if present, else stringified data. */
  detail: z.string(),
  /** Optional symbol pulled from `data.symbol` for breach/news alerts. */
  symbol: z.string().nullable(),
  created_at: z.number().int(),
  /** No persistent read state today — server returns false until a read column is added. */
  read: z.boolean(),
});
export type AlertRow = z.infer<typeof AlertRowZ>;

export const ListAlertsResZ = z.object({
  alerts: z.array(AlertRowZ),
});
export type ListAlertsRes = z.infer<typeof ListAlertsResZ>;
